<template>
  <span @contextmenu.prevent="openContextMenu">
    <!-- シナリオブループリント -->
    <svg class="svg" :width="width" :height="height" :viewBox="viewport" @wheel="zoom"
    @mousedown.self="mouseDown" @mouseup="mouseUp" @mousemove="mouseMove">
      <ConnectPath v-for="(s1, i) in scenarioParts" :key="i" :scenario="s1" :colors="nodeColor" :robolock="selectChatbot.is_confirm"></ConnectPath>
      <ScenarioGroup v-for="(s2, i) in scenarioParts" :key="`A-${i}`" :scenario="s2" :colors="nodeColor" :ratio="ratio" :dx="dx" :dy="dy"
      :multiSelectedParts="multiSelectedParts" :isMultiPartsMove="isMultiPartsMove" :multiPartsRelativePos="multiPartsRelativePos"
      @multiSelect="selectParts" @multiDeselectAll="deselectAllParts" @multiMove="multiPartsMove" :PCTRLLOG="CTRLLOG"></ScenarioGroup>
      <ScenarioMemo v-for="(s3, i) in memoParts" :key="`B-${i}`" :scenario="s3" :colors="nodeColor" :ratio="ratio" :dx="dx" :dy="dy"
      :multiSelectedParts="multiSelectedParts" :isMultiPartsMove="isMultiPartsMove" :multiPartsRelativePos="multiPartsRelativePos"
      @multiSelect="selectParts" @multiDeselectAll="deselectAllParts" @multiMove="multiPartsMove" />
    </svg>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import ConnectPath from '@/views/DashBoard/ChatBot/ConnectPath'
import ScenarioGroup from '@/views/DashBoard/ChatBot/ScenarioGroup'
import _ from 'lodash'
import ScenarioMemo from '@/views/DashBoard/ChatBot/ScenarioMemo'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'BluePrint',
  componentName: 'BluePrint',
  components: {
    ConnectPath,
    ScenarioGroup,
    ScenarioMemo
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'detail', 'editAreaRatio', 'selectChatbot']),
    memoParts () {
      if (this.scenarioTable) return this.scenarioTable.filter((item) => item.status == 22)
      else return []
    },
    scenarioParts () {
      if (this.scenarioTable) return this.scenarioTable.filter((item) => item.status != 22)
      else return this.scenarioTable
    },
    nodeColor() {
      // 各ノードの色を決定し、beforenodeとcolorの組を返す
      // http://www.hp-stylelink.com/news/2013/07/20130708.php
      let bgColorKPIList = {
        '#f2cf01': 0,
        '#c93a40': 0,
        '#fff001': 0,
        '#d06d8c': 0,
        '#65ace4': 0,
        '#a0c238': 0,
        '#56a764': 0,
        '#d16b16': 0,
        '#9460a0': 0,
        '#0074bf': 0,
        }

      let subBGColor = {
        '#f2cf01': '#FEF0A3',
        '#c93a40': '#E8AFB2',
        '#fff001': '#FFF899',
        '#d06d8c': '#E8B9C8',
        '#65ace4': '#B9DAF2',
        '#a0c238': '#E2ECBF',
        '#56a764': '#C9E3CD',
        '#d16b16': '#F4C7A3',
        '#9460a0': '#D3BFD8',
        '#0074bf': '#A3DBFF',
      }
      
      let colors = {}

      let graph = {}
      this.scenarioStructure.forEach((scenario, i) => {graph[scenario.beforenode] = {'before':[], 'next':[]}})
      this.scenarioStructure.forEach((scenario, i) => {
        scenario.select.forEach((sel, j) => {
          if (sel.next_node in graph) {
            if (!graph[sel.next_node].before.includes(scenario.beforenode)) graph[sel.next_node].before.push(scenario.beforenode)
            if (!graph[scenario.beforenode].next.includes(sel.next_node)) graph[scenario.beforenode].next.push(sel.next_node)
          }
        })
      })
    
      let end_nodes = []
      let nodes = {}
      this.scenarioStructure.forEach((scenario, i) => {nodes[scenario.beforenode] = scenario})
      const start_node = this.scenarioStructure.find(s => s.start_flg)
      if (start_node) {
        let queue = [start_node]
        nodes[start_node.beforenode] = 0
        let count = 1
        while (queue.length!=0) {
          let node = queue.shift()
          let end_flg = true
          for (let n of graph[node.beforenode].next) {
            if (n in nodes && nodes[n] && typeof(nodes[n]) != 'number') {
              end_flg = false
              queue.push(nodes[n])
              nodes[n] = count
              count += 1
            }
          }
          if (end_flg) end_nodes.push(node.beforenode)
        }

        while(end_nodes.length!=0) {
          // 接続が最大のエンドノード
          let connect = -1
          let node = null
          end_nodes.forEach((n, i) => {if (graph[n].before.length > connect) {node = n; connect = graph[n].before.length;}})

          // すでに使われている色を探索
          let exist_colors = new Set()
          graph[node].next.forEach((n, i) => {if (n in colors) exist_colors.add(colors[n].color)})
          graph[node].before.forEach((n1, i) => {
            if (n1 in colors) exist_colors.add(colors[n1].color)
            graph[n1].next.forEach((n2, j) => {if (n2 in colors) exist_colors.add(colors[n2].color)})
          })

          //色の決定
          let num = 100000//とても大きい
          let color = null
          if (exist_colors.size == Object.keys(bgColorKPIList).length) {
            Object.keys(bgColorKPIList).forEach((c, i) => {if (bgColorKPIList[c] < num) {color = c; num = bgColorKPIList[c]}})
          } else {
            Object.keys(bgColorKPIList).forEach((c, i) => {if (bgColorKPIList[c] < num && !exist_colors.has(c)) {color = c; num = bgColorKPIList[c]}})
          }
          colors[node] = {'color': color, 'connect_start': true, 'sub_color': subBGColor[color]}
          bgColorKPIList[color] += 1
          end_nodes = end_nodes.filter(n => n!== node)

          //新たにエンドノードになったものを探索
          graph[node].before.forEach((n, i) => {
            if (!(n in colors) && typeof(nodes[n]) == 'number') {
              let yet = graph[n].next.some(n2 => !(n2 in colors || nodes[n] > nodes[n2]))
              if (!yet) end_nodes.push(n)
            }
          })
        }
      }
      
      // 残りのノード適当に
      for (let idx in this.scenarioStructure) {
        if (!(this.scenarioStructure[idx].beforenode in colors)) {
          colors[this.scenarioStructure[idx].beforenode] = {
            'color': Object.values(subBGColor)[idx%Object.keys(bgColorKPIList).length],
            'connect_start': false,
            'sub_color': Object.values(subBGColor)[idx % Object.keys(bgColorKPIList).length]
          }
        }
      }

      return colors
    },
  },
  mounted () {
    this.$store.dispatch('chatbot/getEditAreaRatio')
    this.ratio = 1.55
    this.makeViewBox(this.dx, this.dy, this.width * this.ratio, this.height * this.ratio)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('not-copy')) {
        this.closeContextMenu()
      }
    })
    this.updateScenarioColor()
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeContextMenu)
  },
  watch: {
    scenarioTable () {
      this.$store.dispatch('chatbot/getEditAreaRatio')
      this.updateScenarioColor()
    },
    editAreaRatio () {
      if (this.editAreaRatio > this.ratio) {
        // 計算した倍率が1.55を超える場合はscenarioTableに合わせて広げる
        // そのまま掛けると更に1.55倍されるので75%に倍率を下げて掛ける
        const alignRatio = this.editAreaRatio * 0.75
        this.width = Math.floor(this.width * alignRatio)
        this.height = Math.floor(this.height * alignRatio)
      } else {
        // 計算した倍率が1.55を超えなければそのまま
        this.width = 5000
        this.height = 4000
      }
      this.makeViewBox(this.dx, this.dy, this.width * this.ratio, this.height * this.ratio)
    }
  },
  methods: {
    mouseDown (event) {
      if (event.shiftKey) return
      else this.checkMouseMove = {move: false}
    },
    mouseMove (event) {
      if (this.checkMouseMove) {
        this.checkMouseMove.move = true
      }
    },
    mouseUp (event) {
      if (this.checkMouseMove && !this.checkMouseMove.move) {
        this.deselectAllParts()
      }
      this.checkMouseMove = null
    },
    zoom (e) {
      if (this.scenarioTable.length == 0) return
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      if (e.ctrlKey) {
        if (e.deltaY > 0) {
          w = w * 1.01
          h = h * 1.01
        } else {
          w = w * 0.99
          h = h * 0.99
        }
        this.makeViewBox(x, y, w, h)
        this.ratio = w / this.width
        localStorage.setItem('ratio_' + this.scenarioTable[0].name, this.ratio)
        e.preventDefault()
      }
    },
    zoomBtn (d) {
      if (this.scenarioTable.length == 0) return
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      w = w * d
      h = h * d
      this.viewport = [x, y, w, h].join(' ')
      this.ratio = w / this.width
      localStorage.setItem('ratio_' + this.scenarioTable[0].name, this.ratio)
    },
    makeViewBox (x, y, w, h) {
      this.viewport = [x, y, w, h].join(' ')
    },
    changeMiniMapFlg () {
      this.isMiniMap = !this.isMiniMap
      localStorage.setItem('isMiniMap_' + this.scenarioTable[0].name, this.isMiniMap)
    },
    getIsMiniMap () {
      return this.isMiniMap
    },
    openContextMenu (event) {
      if (event.shiftKey) return
      else this.deselectAllParts()
      let isCopy = Boolean(Number(localStorage.getItem('SCENARIO_IS_COPY')))
      let isCut = Boolean(Number(localStorage.getItem('SCENARIO_IS_CUT')))
      if (isCopy || isCut) {
        let pasteX = 0
        let pasteY = 0
        let menu = document.getElementById('context-menu')
        if (!this.contextMenuWidth || !this.contextMenuHeight) {
          menu.style.visibility = 'hidden'
          menu.style.display = 'block'
          this.contextMenuWidth = menu.offsetWidth
          this.contextMenuHeight = menu.offsetHeight
          menu.removeAttribute('style')
        }

        if ((this.contextMenuWidth + event.pageX) >= window.innerWidth) {
          menu.style.left = (event.pageX - this.contextMenuWidth) + 'px'
        } else {
          menu.style.left = event.pageX + 'px'
        }
        if ((this.contextMenuHeight + event.clientY) >= window.innerHeight) {
          menu.style.top = (event.clientY - this.contextMenuHeight) + 'px'
        } else {
          menu.style.top = event.clientY + 'px'
        }
        pasteX = Math.round(event.offsetX * this.ratio + this.dx)
        pasteY = Math.round(event.offsetY * this.ratio + this.dy)
        this.$store.dispatch('chatbot/setPasteFlg', Boolean(isCopy || isCut), isCopy, isCut)
        this.$store.dispatch('chatbot/setPasteMenu', {pasteX, pasteY})
        menu.classList.add('active')
      }
    },
    closeContextMenu () {
      let contextMenu = document.getElementById('context-menu')
      if (contextMenu) {
        contextMenu.classList.remove('active')
      }
    },
    updateScenarioColor () {
        if (this.scenarioTable) {
        const structure = this.scenarioTable.map((s) => {return {beforenode: s.beforenode, select: s.select.map((s2)=>{return {next_node: s2.next_node}}), start_flg: s.start_flg}})
        if (!_.isEqual(this.scenarioStructure, structure)) {
          this.scenarioStructure = structure
        }
      }
    },
    selectParts (scenario) {
      if (this.multiSelectedParts.filter((item) => item.beforenode == scenario.beforenode).length) {
        this.multiSelectedParts = this.multiSelectedParts.filter((item) => item.beforenode != scenario.beforenode)
      } else {
        this.multiSelectedParts.push(scenario)
      }
    },
    deselectAllParts () {
      this.multiSelectedParts = []
    },
    multiPartsMove (flg) {
      this.isMultiPartsMove = flg
      if (this.isMultiPartsMove) {
        // 各パーツと、上下左右端のパーツの相対位置を算出
        this.multiPartsRelativePos = {}
        let top = Infinity, bottom = 0, left = Infinity, right = 0
        for (let scenario of this.multiSelectedParts) {
          top = Math.min(top, scenario.beforenodeY)
          bottom = Math.max(bottom, scenario.beforenodeY)
          left = Math.min(left, scenario.beforenodeX)
          right = Math.max(right, scenario.beforenodeX)
        }
        for (let scenario of this.multiSelectedParts) {
          this.multiPartsRelativePos[scenario.beforenode] = {
            top: top - scenario.beforenodeY,
            bottom: bottom - scenario.beforenodeY,
            left: left - scenario.beforenodeX,
            right: right - scenario.beforenodeX
          }
        }
      }
    }
  },
  data () {
    return {
      rxSize: 15,
      width: 5000,
      height: 4000,
      ratio: 1,
      dx: 0,
      dy: 0,
      mapX: 0,
      mapY: 0,
      isMouseDown: false,
      isMouseUp: false,
      isMiniMap: true,
      viewport: '0 0 5000 4000',
      viewportMap: '0 0 5000 4000',
      multiSelectedParts: [],
      checkMouseMove: null,
      isMultiPartsMove: false,
      multiPartsRelativePos: null,
      scenarioStructure: []
    }
  }
}
</script>

<style scoped>
.svg {
  background-color: #f9f9f9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2392aca4' fill-opacity='0.62'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.svg-map {
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.75;
  border: solidthin #ccc;
  border-radius: 5px;
  background-color: #666;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/BluePrint.vue